import React from "react";
import styled from "styled-components";
import { IAccordionData } from "../../commonTypes";
import AccordionItems from "./AccordionItems";

const Container = styled.main`
  position: relative;
  width: 100%;
`;

const Section = styled.section`
  position: relative;
`;

const InnerSection = styled.div`
  position: relative;
  width: 100%;
`;

const AccordionContainer = styled.div`
  background: ${({ theme }) => theme.backgroundColor};
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;
`;

const AccordionInner = styled.div`
  position: relative;
  width: 100%;
`;

interface IAccordionBoxProps {
  content: IAccordionData[];
  openOnMount?: boolean;
}

const AccordionBox = ({ content, openOnMount = false }: IAccordionBoxProps) => {
  return (
    <Container>
      <Section>
        <InnerSection>
          <AccordionContainer>
            <AccordionInner>
              <AccordionItems
                accordionContent={content}
                openOnMount={openOnMount}
              />
            </AccordionInner>
          </AccordionContainer>
        </InnerSection>
      </Section>
    </Container>
  );
};

export default AccordionBox;
